// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"6d16cecf","670":"ef702f39"}[chunkId] + ".chunk.css";
};